'use client';

import { useEffect, useState } from 'react';

import { Breakpoint, MediaQuery } from '~/ui/styles/grid';

export function useBreakpoint(breakpoint: Breakpoint): boolean;
export function useBreakpoint(): Breakpoint;
/**
 * Hook to determine the current breakpoint.
 *
 * If no breakpoint is provided, it will return a {@link Breakpoint} enum value. If a
 * {@link Breakpoint} is provided, it will return a boolean indicating whether it is the current
 * breakpoint.
 */
export function useBreakpoint(breakpoint?: Breakpoint) {
  const [currentBreakpoint, setCurrentBreakpoint] = useState<Breakpoint>(Breakpoint.MOBILE);

  useEffect(() => {
    const cleanupFns = Object.values(Breakpoint).map(bp => {
      const mediaQuery = window.matchMedia(MediaQuery[bp]);
      // Set the initial breakpoint
      if (mediaQuery.matches) {
        setCurrentBreakpoint(bp);
      }
      const onChange = (event: MediaQueryListEvent) => {
        if (event.matches) {
          setCurrentBreakpoint(bp);
        }
      };
      mediaQuery.addEventListener('change', onChange);
      return () => mediaQuery.removeEventListener('change', onChange);
    });
    return () => cleanupFns.forEach(fn => fn());
  }, []);

  return breakpoint ? breakpoint === currentBreakpoint : currentBreakpoint;
}
